// Port of api/fuel/app/classes/insights/players/wins.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function bucketIndex(value, edges) {
	value = parseFloat(value)
	if (value <= parseFloat(edges[0])) return 0
	if (value <= parseFloat(edges[1])) return 1
	if (value <= parseFloat(edges[2])) return 2
	return 3
}

function percentiles(values, ps) {
	var sorted = values.slice().sort(function(a, b) { return a - b })
	var n = sorted.length
	if (!n) return ps.map(function() { return 0 })
	return ps.map(function(p) {
		var rank = Math.max(0, Math.min(n - 1, Math.round((parseFloat(p) / 100) * (n - 1))))
		return sorted[rank]
	})
}

function buildWinRateGrid(opponents, opts) {
	opts = opts || {}
	var minGames = opts.min_games || 1
	var mode = opts.mode || 'percentile'
	var xEdges = opts.x_edges || [2, 5, 15]
	var yEdges = opts.y_edges || [0.25, 0.45, 0.55]

	if (mode === 'percentile') {
		var games = []
		for (var i = 0; i < opponents.length; i++) {
			var g = parseInt(opponents[i].plays, 10) || 0
			if (g >= minGames) games.push(g)
		}
		if (games.length) xEdges = percentiles(games, opts.percentiles_x || [25, 50, 75])
	}

	var counts = [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0]]
	var cells = [[[], [], [], []], [[], [], [], []], [[], [], [], []], [[], [], [], []]]

	for (var o = 0; o < opponents.length; o++) {
		var gamesPlayed = parseInt(opponents[o].plays, 10) || 0
		if (gamesPlayed < minGames) continue
		var rate = parseFloat(opponents[o].count) || 0
		if (rate < 0) rate = 0
		if (rate > 1) rate = 1
		var xi = bucketIndex(gamesPlayed, xEdges)
		var yi = bucketIndex(rate, yEdges)
		counts[yi][xi] += 1
		cells[yi][xi].push(opponents[o])
	}

	return {
		counts: counts,
		cells: cells
	}
}

function gridToList(raw) {
	return [
		raw.counts[3][0], raw.counts[3][1], raw.counts[2][0], raw.counts[2][1],
		raw.counts[3][2], raw.counts[3][3], raw.counts[2][2], raw.counts[2][3],
		raw.counts[1][0], raw.counts[1][1], raw.counts[0][0], raw.counts[0][1],
		raw.counts[1][2], raw.counts[1][3], raw.counts[0][2], raw.counts[0][3]
	]
}

function selectBand(cells, band, fallback) {
	var map = [
		[3, 0], [3, 1], [2, 0], [2, 1],
		[3, 2], [3, 3], [2, 2], [2, 3],
		[1, 0], [1, 1], [0, 0], [0, 1],
		[1, 2], [1, 3], [0, 2], [0, 3]
	]
	var coords = map[parseInt(band, 10)]
	return coords ? cells[coords[0]][coords[1]] : fallback
}

export default Segment.extend({
	name: 'wins',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: ['wins.band', 'wins.threshold'],
	detail: ['wins'],
	run: function(type, owner, userIndex, detail, filter) {
		var data = {
			list: [],
			grid: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
			total: 0
		}
		var band = (filter && filter['wins.band'] !== undefined) ? filter['wins.band'] : false
		var threshold = (filter && filter['wins.threshold'] !== undefined) ? parseInt(filter['wins.threshold'], 10) : 3
		var limit = detail ? 250 : 5
		var players = []

		for (var i = 0; i < (this._data.players || []).length; i++) {
			var player = this._data.players[i]
			if (player.totalPlays > threshold) {
				var winTotal = Object.keys(player.plays || {}).reduce(function(total, key) {
					return total + (parseInt(player.plays[key], 10) || 0)
				}, 0)
				players.push({
					id: parseInt(player.id, 10) || 0,
					slug: player.slug,
					name: player.primaryName,
					username: player.username,
					plays: player.totalPlays,
					count: winTotal ? ((1 / player.totalPlays) * winTotal) : 0
				})
			}
		}

		var raw = buildWinRateGrid(players)
		data.grid = gridToList(raw)

		if (band !== false && band !== null) players = selectBand(raw.cells, band, players)
		data.total = players.length

		players = Util.sort_by_field(players, 'count', 'desc')
		if (players.length > limit) players = players.slice(0, limit)
		data.list = players

		for (var p = 0; p < data.list.length; p++) {
			data.list[p].count = Math.round((data.list[p].count * 100) * 100) / 100
		}

		return {
			wins: data
		}
	}
})
